import React from 'react';
import './BirthdayIndicator.scss';

interface BirthdayIndicatorProps {
    daysUntilBirthday: number;
    showText?: boolean;
}

const BirthdayIndicator = ({ daysUntilBirthday, showText = true }: BirthdayIndicatorProps) => {
    const getText = () => {
        if (daysUntilBirthday === 0) return 'Today!';

        const targetDate = new Date();
        targetDate.setDate(targetDate.getDate() + daysUntilBirthday);
        const dayName = targetDate.toLocaleDateString('en-US', { weekday: 'long' });

        if (daysUntilBirthday > 0) {
            return `This ${dayName}`;
        }
        return `Last ${dayName}`;
    };

    const confettiPieces = ['🎊', '🎉', '✨', '🎈', '🎁', '⭐', '💫', '🌟'];

    return (
        <span className={`birthday-indicator ${!showText ? 'animation-only' : ''}`}>
            <span className="confetti-container">
                {confettiPieces.map((piece, index) => (
                    <span key={index} className={`confetti-piece piece-${index}`}>
                        {piece}
                    </span>
                ))}
            </span>
            {showText && <span className="birthday-text">{getText()}</span>}
        </span>
    );
};

export default BirthdayIndicator;
